import React, { Children } from 'react';
import cx from 'classnames';
import styles from './ListItem.module.scss';
import { ListItemProps } from "./ListItem.types";
import { WrapTextNodes } from '../../utils/WrapTextNodes';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';

const ListItem = (props: ListItemProps) => {
  const {
    className,
    leadingIcon,
    trailingIcon,
    onClick,
    children,
    disabled,
    ...restProps
  } = props;

  let leadingIconComponent, trailingIconComponent, content;

  // Render leading icon if it is passed
  if (leadingIcon) {
    leadingIconComponent = <div className={styles.leadingIcon}>
      {leadingIcon}
    </div>;
  }

  // Render training icon if it is passed
  if (trailingIcon) {
    trailingIconComponent = <div className={styles.trailingIcon}>
      {trailingIcon}
    </div>;
  }

  if (children) {
    content = <div className={styles.content}>
      <WrapTextNodes className={styles.text}>
        {children}
      </WrapTextNodes>
    </div>;
  }

  const variantProps = useBuildVariantProps(
    'list-item',
    {},
    { disabled },
  );


  return (
    <div
      className={cx(styles.listItem, className)}
      onClick={onClick}
      tabIndex={0}
      {...variantProps}
      {...restProps}
    >
      {leadingIconComponent}
      {content}
      {trailingIconComponent}
    </div>
  );
};

export default ListItem;
